import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function Loading({ mode = 'container' }) {
  return (
    <div className={`app-loader ${mode}--loading`}>
      <div className='loading' />
    </div>
  );
}

Loading.propTypes = {
  mode: PropTypes.string,
};

export default Loading;
